import AreaOfExperties from "../../../components/Filters_Teammates/AreaOfExpertiesFilter";
import DescriptionFilter from "../../../components/Filters_Teammates/DescriptionFilter";
import ForGratification from "../../../components/Filters_Teammates/ForGratificationFilter";
import OfferedGratification from "../../../components/Filters_Teammates/OfferedGratificationFilter";
import ProductType from "../../../components/Filters_Teammates/ProductTypeFilter";
import ProjectType from "../../../components/Filters_Teammates/ProjectTypeFilter";
import TeammateNickname from "../../../components/Filters_Teammates/TeammateNicknameFilter";
import ToolsExperienceFilter from "../../../components/Filters_Teammates/ToolsExperienceFilter";
// import ExperienceTools from "../../../components/InputFields/ExperienceTools";
import axios from "axios";
import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import ProjectDeadline from "../../../components/Filters_Projects/ProjectDeadlineFilter";
import { url } from "../../../url";
import { useDataFromAddTeammate } from "../../../utils/useDataFromAddTeammate";
import { useOpenCloseFiltersAddTeammate } from "../../../utils/useOpenCloseFiltersAddTeammate";
import { openAtom, pageAtom } from "../atoms/AddTeammateAtomGlobal";
import {
  forGratificationAtom,
  nicknameAtom,
  offeredGratificationAtom,
  productTypeAtom,
  projectDeadlineAtom,
  projectTypeAtom,
  requiredAreaOfExpertiseAtom,
  softSkillsAtom,
  toolsExperienceAtom,
  toolsExperienceOptionViewsAtom,
} from "../atoms/AddTeammateAtomPage1";

import OfferedWorkingType from "../../../components/Filters_Teammates/OfferedWorkingTypeFilter";

import {
  descriptionAtom,
  hardSkillsAtom,
  offeredWorkingTypeActiveOptionsAtom,
  offeredWorkingTypeAtomNewArray,
} from "../atoms/AddTeammateAtomPage2";

import {
  HardSkillsFilter,
  LocationFilter,
  SoftSkillsFilter,
  UsedLanguagesFilter,
} from "../../../components/common";
import Availability from "../../../components/Filters_Teammates/RequiredAvailabilityFilter";
import { FILTERS } from "../../../filters/filtersConfig";
import {
  bizOrTechRoleAtomLeftValue,
  bizOrTechRoleAtomRightValue,
  locationsAtom,
  requiredAvailabilityAtomStartValue,
  usedLanguagesAtom,
} from "../atoms/AddTeammateAtomPage3";

import RequiredFieldIcon from "../../../components/common/RequiredFieldIcon";
import "./NewAddTeammate.scss";

const Page1 = () => {
  const setPage = useSetAtom(pageAtom);
  const [nickname, setNickname] = useAtom(nicknameAtom);
  const [toolsExperience, setToolsExperience] =
    useAtom<string[]>(toolsExperienceAtom);
  const [toolsExperienceOptionViews, setToolsExperienceOptionViews] = useAtom(
    toolsExperienceOptionViewsAtom
  );
  const [projectType, setProjectType] = useAtom<string[]>(projectTypeAtom);
  const [productType, setProductType] = useAtom<string[]>(productTypeAtom);
  const [offeredGratification, setOfferedGratification] = useAtom<string[]>(
    offeredGratificationAtom
  );
  const [projectDeadline, setProjectDeadline] = useAtom(projectDeadlineAtom);
  const [softSkills, setSoftSkills] = useAtom<string[]>(softSkillsAtom);
  const [requiredAreaOfExpertise, setRequiredAreaOfExpertise] = useAtom<
    string[]
  >(requiredAreaOfExpertiseAtom);
  const [forGratification, setForGratification] =
    useAtom<string[]>(forGratificationAtom);
  const data = useDataFromAddTeammate();
  const navigate = useNavigate();

  const openFilters = useAtomValue(openAtom);
  const enableAndResetFilters = useOpenCloseFiltersAddTeammate();

  // Page2
  const [hardSkills, setHardSkills] = useAtom<string[]>(hardSkillsAtom);
  const [offeredWorkingTypeNewArray, setOfferedWorkingTypeNewArray] = useAtom<
    string[]
  >(offeredWorkingTypeAtomNewArray);
  const [offeredWorkingTypeActiveOptions, setOfferedWorkingTypeActiveOptions] =
    useAtom<boolean[]>(offeredWorkingTypeActiveOptionsAtom);
  const [description, setDescription] = useAtom(descriptionAtom);

  const clearFilters = () => {
    setNickname("");
    setToolsExperience([]);
    setProjectType([]);
    setProductType([]);
    setOfferedGratification([]);
    setProjectDeadline(0);
    setSoftSkills([]);
    setRequiredAreaOfExpertise([]);
    setForGratification([]);
    setHardSkills([]);
    setOfferedWorkingTypeNewArray([]);
    setOfferedWorkingTypeActiveOptions([]);
    setDescription("");
  };

  const onClickSubmitButton = async () => {
    const token = localStorage.getItem("token");
    try {
      if (
        nickname.length &&
        toolsExperience.length &&
        projectType.length &&
        productType.length &&
        offeredGratification.length &&
        forGratification.length
      ) {
        const res = await axios.post(url + "/teammate", data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        console.log(res.data);
        clearFilters();
        navigate(`/teammates`);
      } else {
        alert("You need to fill required fields");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const [usedLanguages, setUsedLanguages] =
    useAtom<string[]>(usedLanguagesAtom);
  const [bizOrTechRoleLeftValue, setBizOrTechRoleLeftValue] = useAtom(
    bizOrTechRoleAtomLeftValue
  );
  const [bizOrTechRoleRightValue, setBizOrTechRoleRightValue] = useAtom(
    bizOrTechRoleAtomRightValue
  );
  const [requiredAvailability, setRequiredAvailability] = useAtom(
    requiredAvailabilityAtomStartValue
  );
  const [locations, setLocations] = useAtom<string[]>(locationsAtom);

  return (
    <div style={{ width: "100%", padding: "20px" }}>
      <div className="page1_component" style={{ maxWidth: "100%" }}>
        <div className="columns-container-teammate">
          <div className="column-teammate">
            {/* OBLIGATORY FIELDS*/}
            <div style={{ position: "relative" }}>
              <RequiredFieldIcon />
              <TeammateNickname
                teammateNickname={nickname}
                setTeammateNickname={setNickname}
                show={openFilters.teammateNickname}
                setShow={enableAndResetFilters}
              />
            </div>
            <div style={{ position: "relative" }}>
              <RequiredFieldIcon />
              <ProductType
                pickedOptions={productType}
                setPickedOptions={setProductType}
                show={openFilters.productType}
                setShow={enableAndResetFilters}
                displayColumn={true}
                title={FILTERS.productType.label}
                isAdd={true}
              />
            </div>
            <div style={{ position: "relative" }}>
              <RequiredFieldIcon />
              <ToolsExperienceFilter
                pickedOptions={toolsExperience}
                setPickedOptions={setToolsExperience}
                optionViews={toolsExperienceOptionViews}
                setOptionViews={setToolsExperienceOptionViews}
                show={openFilters.toolsExperience}
                setShow={enableAndResetFilters}
                displayColumn={true}
                isAdd={true}
              />
            </div>
            <div style={{ position: "relative" }}>
              <RequiredFieldIcon />
              <ProjectType
                pickedOptions={projectType}
                setPickedOptions={setProjectType}
                show={openFilters.projectType}
                setShow={enableAndResetFilters}
                displayColumn={true}
                isAdd={true}
              />
            </div>
            <div style={{ position: "relative" }}>
              <RequiredFieldIcon />
              <OfferedGratification
                pickedOptions={offeredGratification}
                setPickedOptions={setOfferedGratification}
                show={openFilters.offeredGratification}
                setShow={enableAndResetFilters}
                displayColumn={true}
                isAdd={true}
              />
            </div>
            <div style={{ position: "relative" }}>
              <RequiredFieldIcon />
              <ForGratification
                pickedOptions={forGratification}
                setPickedOptions={setForGratification}
                show={openFilters.forGratification}
                setShow={enableAndResetFilters}
                displayColumn={true}
                isAdd={true}
              />
            </div>
            {/* OPTIONAL */}

            <HardSkillsFilter
              pickedOptions={hardSkills}
              setPickedOptions={setHardSkills}
              show={openFilters.hardSkills}
              setShow={enableAndResetFilters}
              displayColumn={true}
              isAdd={true}
            />
            <AreaOfExperties
              pickedOptions={requiredAreaOfExpertise}
              setPickedOptions={setRequiredAreaOfExpertise}
              show={openFilters.requiredAreaOfExpertise}
              setShow={enableAndResetFilters}
              displayColumn={true}
              isAdd={true}
            />
            {/* Willing to Collab Until */}

            <ProjectDeadline
              value={projectDeadline}
              setValue={setProjectDeadline}
              open={openFilters.projectDeadline}
              setOpen={enableAndResetFilters}
              title={FILTERS.projectDeadline.label}
              showFilterType={false}
              isAdd={true}
            />
          </div>

          <div className="column-teammate">
            <SoftSkillsFilter
              pickedOptions={softSkills}
              setPickedOptions={setSoftSkills}
              show={openFilters.softSkills}
              setShow={enableAndResetFilters}
              displayColumn={true}
              isAdd={true}
            />

            {/* <BizOrTechRole
              leftValue={bizOrTechRoleLeftValue}
              setLeftValue={setBizOrTechRoleLeftValue}
              rightValue={bizOrTechRoleRightValue}
              setRightValue={setBizOrTechRoleRightValue}
              open={openFilters.bizOrTech}
              setOpen={enableAndResetFilters}
            /> */}

            <Availability
              value={requiredAvailability}
              setValue={setRequiredAvailability}
              open={openFilters.requiredAvailability}
              setOpen={enableAndResetFilters}
              title={FILTERS.requiredAvailability.label}
              isAdd={true}
            />

            <OfferedWorkingType
              newArray={offeredWorkingTypeNewArray}
              setNewArray={setOfferedWorkingTypeNewArray}
              activeOptions={offeredWorkingTypeActiveOptions}
              setActiveOptions={setOfferedWorkingTypeActiveOptions}
              show={openFilters.offeredWorkingType}
              setShow={enableAndResetFilters}
              isAdd={true}
            />

            <LocationFilter
              pickedOptions={locations}
              setPickedOptions={setLocations}
              show={openFilters.locations}
              setShow={enableAndResetFilters}
              displayColumn={true}
              isAdd={true}
            />

            <UsedLanguagesFilter
              pickedOptions={usedLanguages}
              setPickedOptions={setUsedLanguages}
              show={openFilters.usedLanguages}
              setShow={enableAndResetFilters}
              displayColumn={true}
              isAdd={true}
            />

            <DescriptionFilter
              description={description}
              setDescription={setDescription}
              show={openFilters.description}
              setShow={enableAndResetFilters}
              title={FILTERS.productDescription.label}
            />
          </div>
        </div>
      </div>
      <div className="buttons_container">
        <div>
          <button className="submit_btn" onClick={onClickSubmitButton}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};
export default Page1;
